.eventDetails span,
.eventDetails p {
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
}
